import React, { useMemo } from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import SelectField from '../../../../BaseModule/Components/Form/Components/SelectField/SelectField';
import { SelectValue } from '../../../../BaseModule/Components/Select';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.SELECT }>;
}

const WizardSelect: React.FC<Props> = ({ item }) => {
	const options: SelectValue[] = useMemo(() => {
		return item.children.map(i => {
			return { label: i.title, value: i.value as string };
		});
	}, [item]);

	return (
		<SelectField
			options={options}
			name={item.key}
			label={item.title}
			isRequired={item.settings.required}
			isWrapped
			portal
		/>
	);
};

export default WizardSelect;
